<template>
    <div class="filter-free-mileage-box px-3 position-relative">
        <p class="mb-2"><b>{{$t('cat.filter.duration_option')}}</b></p>
        <p class="filter-reset-icon" v-if="hasChanged">
            <font-awesome-icon icon="fa-minus-circle" class="text-link" @click="resetFilter"/>
        </p>
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-0">
                    <b-form-radio
                        v-for="option in options"
                        v-model="selected"
                        :value="option.value"
                        :key="option.value"
                    >
                        {{ $t(option.text) }}
                    </b-form-radio>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BSkeleton, BFormRadioGroup, BFormRadio, BFormGroup } from "bootstrap-vue"
import { EventBus } from "../../event-bus"

export default {
    name: 'FilterDurationOptionBox',
    components: {
        BSkeleton, BFormRadioGroup, BFormRadio, BFormGroup
    },
    data() {
        return {
            changedByUrl: false,
            isLoading: true,
            setup: true,
            dataLoader: null,
            selected: -1,
            options: [
                { text: 'cat.filter.duration.any', value: -1 },
                { text: 'cat.filter.duration.flexible', value: 0 },
                { text: 'cat.filter.duration.fix', value: 1 },
            ],
        }
    },
    methods: {
        resetFilter(){
            this.changedByUrl = false
            this.selected = -1

            EventBus.$emit('update-catalog-filter', {filter: 'duration_options', value: -1})
        },

        getFilterData(data){
            if(this.$route.query.duration_options){
                this.changedByUrl = true
                const selectedVal = this.$route.query.duration_options.replace(/[^0-9,-]/g, '').split(',')
                const exists = this.options.find(d => d.value === parseInt(selectedVal[0]))
                this.selected = exists ? exists.value : -1
            } else {
                this.selected = -1
            }

            this.isLoading = false
        },
    },
    computed: {
        hasChanged() {
            return this.selected !== -1
        }
    },
    watch: {
        selected: function (val) {
            EventBus.$emit('update-catalog-filter', {filter: 'duration_options', value: this.selected})
        },
    },
    mounted() {
        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
